import MainSideBar from "@/components/layout/navigation/sidebar";
import { useMenu } from "@/hooks/useMenu";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

export default function MainLayout({ organisation, children }) {
  const [collapseSidebar, setCollapseSidebar] = useState(false);
  const { menuOpen } = useMenu();
  const [selectedLink, setSelectedLink] = useState("overview");

  const router = useRouter();

  useEffect(() => {
    // TODO: Add Links Back in
    const links = {
      // "/": "overview",
      "/accounts": "accounts",
      "/operations": "operations",
      "/past-orders": "past-orders",
      "/devices": "devices",
      "/reports": "reports",
      "/redeemables": "redeemables",
      "/settings": "settings",
      "/support": "support",
    };

    const path = router.pathname;
    const baseRoute = `/${path.split("/")[1]}`;
    setSelectedLink(links[baseRoute] || "overview");
  }, [router.pathname]);

  return (
    <div className="w-full">
      <div className="flex">
        <div
          id="main-sidebar-container"
          className={`-z-0 h-full overflow-auto bg-dines-purple md:block ${
            menuOpen
              ? `fixed left-0 z-10 block w-full md:block ${
                  collapseSidebar ? "md:w-24" : "md:w-64"
                }`
              : `hidden md:block ${
                  collapseSidebar ? "w-24" : "w-64"
                } fixed top-0 right-0 bottom-0 left-0 z-10`
          }`}
        >
          <MainSideBar
            organisation={organisation}
            selected={selectedLink}
            setCollapseSidebar={setCollapseSidebar}
            collapseSidebar={collapseSidebar}
          />
        </div>
        <div
          className={`w-full ${collapseSidebar ? "md:pl-24 " : "md:pl-64 "} bg-dines-purple-light ${menuOpen ? "hidden" : ""}`}
          style={{
            boxShadow: "-1px 0 #e3e8ee",
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
